const ParcoSvg = (props) => {
    switch (props.type) {
      case "amenity_library":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            fill="currentColor"
            {...props}
          >
            <path
              className="st1"
              d="M.6 4.6H4.4c.2 0 .2 0 .2.2v7.8c0 .1 0 .2-.2.2H.5c.1-2.8.1-5.5.1-8.2zm.8 1.9v.9c0 .2.1.3.3.3h1.8c.2 0 .3-.1.3-.3V5.5c0-.2-.1-.3-.3-.3H1.7c-.2 0-.3.1-.3.3v1zM.6 14.1h3.7c.2 0 .2 0 .2.2v1c0 .2-.1.3-.3.3H.9c-.1 0-.2 0-.3-.2v-1.3zM.6 3c.1-.2.2-.2.4-.2h3.2c.3 0 .4.1.4.4v.7c0 .1 0 .1-.1.1H.7C.6 3.7.6 3.3.6 3zM8.1.9c.1.1.2.2.2.3v.4c0 .2 0 .2-.2.2H5.3c-.3.1-.3.1-.3-.1v-.4c0-.1 0-.3.1-.4h3zM.6 13.2h3.8c.1 0 .2 0 .2.2 0 .5 0 .4-.4.4H.6v-.6zM8.3 3.9c.1-.1.2-.1.3-.1 1.2-.3 2.3-.6 3.5-.9.2-.1.3 0 .4.2l.3 1.2c0 .1 0 .2-.1.2-1.3.3-2.6.7-3.9 1-.1 0-.2 0-.2-.1-.1-.4-.2-.8-.3-1.1v8.1c0 .2 0 .2-.2.2H5.3c-.2 0-.2 0-.2-.2V3.6c0-.2 0-.2.2-.2h2.8c.2.1.2.1.2.5 0-.1 0 0 0 0z"
            />
            <path
              className="st1"
              d="M10.5 12.4c-.1 0-.1-.1-.1-.1-.2-.6-.3-1.3-.5-1.9L9 7.1c0-.2 0-.2.1-.2 1.3-.3 2.6-.7 3.8-1 .2 0 .2-.1.2.1.4 1.7.9 3.4 1.3 5.1 0 .1 0 .2-.1.2-1.2.4-2.5.7-3.8 1.1zM15.4 14.4c0 .2-.1.2-.2.3-.6.2-1.2.3-1.7.5-.6.2-1.2.3-1.8.5-.3.1-.4 0-.4-.3-.1-.3-.1-.6-.2-.9 0-.1 0-.2.1-.2l3.3-.9c.2-.1.4-.1.6-.2.1 0 .1 0 .1.1 0 .4.1.7.2 1.1zM6.6 14.1H8c.1 0 .2 0 .2.2v1c0 .3-.1.3-.4.3H5.3c-.3 0-.3-.1-.3-.3v-1c0-.1 0-.2.2-.2h1.4zM10.9 13.9c-.1 0-.1-.1 0 0-.2-.4-.2-.6-.3-.9 0-.1 0-.1.1-.1.5-.1 1.1-.3 1.6-.4.8-.2 1.5-.4 2.3-.6.1 0 .2 0 .2.1.1.2.1.5.2.7 0 .1 0 .2-.1.2-1 .3-2 .5-3 .8-.4 0-.7.1-1 .2 0-.1 0-.1 0 0zM6.6 2.3H8c.1 0 .2 0 .2.2v.4c0 .1 0 .2-.2.2H5.1s-.1 0-.1-.2v-.5c0-.1 0-.2.2-.2.5.1 1 .1 1.4.1zM13 5.3c0 .1-.1.1-.1.1-.7.2-1.3.4-2 .5-.6.2-1.3.4-1.9.6-.1 0-.2 0-.2-.1-.1-.4-.1-.4.3-.6 1.2-.3 2.4-.6 3.6-1 .2 0 .2 0 .3.2v.3zM6.6 13.7H5.1c-.1 0-.2 0-.2-.2 0-.4 0-.4.4-.4H8c.2 0 .2 0 .2.2 0 .4 0 .3-.3.3-.4.1-.8.1-1.3.1z"
            />
          </svg>
        );
      case "social_facility":
        return (
          <svg
            version="1.1"
            {...props}
            id="svg2"
            x="0px"
            y="0px"
            viewBox="0 0 14 14"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            fill="currentColor"
          >
            <path
              d="M7.008.041c-.828 0-1.5.652-1.5 1.457 0 .806.67 1.459 1.5 1.459.829 0 1.5-.653 1.5-1.459 0-.805-.672-1.457-1.5-1.457zM1.5 1.5A.5.5 0 0 0 1 2v6c0 1 0 1 1.168 2C2.999 11 3 11 3 12v2h3v-3c0-.79-.413-.737-1-1-1.739-1-3-2-3-3V2a.5.5 0 0 0-.5-.5zm11 0a.5.5 0 0 0-.5.5v5c0 1-1.261 2-3 3-.587.263-1 .21-1 1v3h3v-2c0-1 0-1 .832-2C13.001 9 13 9 13 8V2a.5.5 0 0 0-.5-.5zM7 4C5 4 5 5 5 6v3h4V6c0-1 0-2-2-2z"
              className="st1"
            />
          </svg>
        );
      case "amenity_pharmacy":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={14}
            fill="currentColor"
            {...props}
          >
            <path d="M4 4 2 6v8h10V6l-2-2zm2 2h2v2h2v2H8v2H6v-2H4V8h2zM4 0v3h6V0z" />
          </svg>
        );
      case "amenity_atm":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M.2 11.7V4.1c.2-.8 1-1.3 1.8-1.3h12.1c1 0 1.8.8 1.8 1.8v6.8c0 1-.8 1.8-1.8 1.8H2c-.3 0-.5-.1-.8-.2-.6-.2-.9-.7-1-1.3zm12.6-3.9c.1 0 .1 0 0 0v2.5c.1.2.2.3.4.3s.4-.1.4-.3V5.9c-.1-.3-.4-.4-.6-.3-.1 0-.2.1-.3.3-.2.4-.5.8-.7 1.3 0 .1-.1.2-.1.2.1-.2.1-.4 0-.4-.3-.4-.5-.9-.8-1.3-.1-.2-.3-.3-.5-.2-.2.1-.3.2-.3.5v4.2c0 .3.2.5.5.5s.5-.2.5-.5V7.9l.1.1c.1.2.2.3.3.5.1.2.2.2.4.2s.3-.1.4-.2c.1-.3.2-.5.3-.7zm-7.4.7V6.9c0-.9-.9-1.6-1.8-1.5-.9.2-1.4.8-1.4 1.7v3.2c.1.2.2.3.4.3s.4-.1.4-.3V9.1c0-.2 0-.2.2-.2h.9c.1 0 .2 0 .2.2v1.1c0 .1 0 .2.1.3.1.2.3.2.5.2.2-.1.3-.2.3-.4.2-.7.2-1.3.2-1.8zm1.8-.2v1.8c0 .2.2.4.4.4s.5-.2.5-.4V6.5c0-.3 0-.2.3-.3h.4c.3 0 .4-.2.4-.5s-.2-.5-.4-.5H6.5c-.2 0-.4.2-.4.5 0 .2.2.4.4.5H7c.2 0 .2 0 .2.2v1.9z"
            />
            <path
              className="st1"
              d="M3.8 7.9h-.5c-.1 0-.2-.1-.2-.2V7c0-.4.3-.6.6-.7.3 0 .7.3.7.6v.8c0 .1-.1.1-.1.1-.2.1-.4.1-.5.1z"
            />
          </svg>
        );
      case "amenity_church":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            fill="currentColor"
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M.4 12.1c.9-.5 1.8-1 2.6-1.5.2-.1.2-.1.2.1v4.2c0 .2 0 .2-.2.2H.4v-3zM3.6 12V9.1c0-.1 0-.2.1-.3 1.4-1.1 2.7-2.3 4.1-3.4.2-.1.2 0 .3 0 1.3 1.1 2.6 2.2 3.9 3.2.2.2.3.4.3.6v5.5c0 .2 0 .2-.2.2H9.6c-.2 0-.2 0-.2-.2v-2.3c0-.6-.3-1.1-.8-1.4-.8-.4-1.9.1-2.1 1.1V14.8c0 .2 0 .2-.2.2H3.8c-.1 0-.2 0-.2-.2V12z"
            />
            <path
              className="st1"
              d="M8.4 2.9c0 .6 0 .5.4.8 1.8 1.5 3.6 3 5.4 4.4.2.1.2.1 0 .3-.2.2-.4.4-.5.6-.1.1-.1.1-.2 0-1-.8-2-1.6-2.9-2.4-.8-.7-1.6-1.3-2.4-2-.2.1-.2.1-.3.2-1.8 1.4-3.5 2.9-5.3 4.3-.2.1-.2.1-.3 0-.2-.2-.3-.5-.5-.7-.1-.1-.1-.1 0-.2 1.3-1 2.5-2.1 3.8-3.1.6-.5 1.3-1 1.9-1.6.1-.1.1-.1.1-.2v-.8c0-.1 0-.1-.2-.1h-.8c-.1 0-.2 0-.2-.2v-.4c0-.1 0-.2.2-.2h.8c.1 0 .2 0 .2-.2V.9c0-.1 0-.1.1-.1h.4c.1 0 .1 0 .1.1v.5c0 .1 0 .2.2.2h.7c.1 0 .2.1.2.2v.4c0 .1 0 .2-.2.2h-.7c-.1 0-.2 0-.2.2.2.1.2.2.2.3zM12.8 12.8v-2.1c0-.2 0-.2.2-.1.8.5 1.7 1 2.5 1.5.1.1.1.1.1.2V15c0 .1 0 .2-.2.2h-2.5c-.1 0-.2 0-.2-.2.1-.8.1-1.5.1-2.2z"
            />
          </svg>
        );
      case "amenity_cinema":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            fill="currentColor"
            xmlSpace="preserve"
            {...props}
          >
            <path d="M15.6 13.4v.3c-.1.2-.3.3-.5.3s-.3-.1-.4-.2c-.9-.5-1.8-.6-2.8-.5-.7.1-1.4.3-2.1.6-1.3.6-2.7.8-4.1.5-3.6-.7-6-4.3-5.2-7.9.8-3.7 4.4-6 8.1-5.1 3.4.8 5.6 4.2 5 7.7-.2 1.1-.7 2.1-1.4 3 0 0-.1.1-.1.2s.1 0 .2 0c1.1 0 2.1.2 3 .7.1.2.3.3.3.4zm-11.8-8c-.8 0-1.5.6-1.5 1.4 0 .7.6 1.4 1.3 1.4.8 0 1.5-.5 1.5-1.3.1-.8-.6-1.5-1.3-1.5zm8 1.4c0-.7-.6-1.4-1.4-1.4-.9 0-1.5.7-1.5 1.5 0 .7.7 1.4 1.5 1.3.8 0 1.4-.6 1.4-1.4zm-5.4 3.9c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4zm2.1-6.3C8.5 3.7 7.8 3 7 3c-.7 0-1.4.7-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.5-.6 1.5-1.4zm2 6.3c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .7.6 1.4 1.4 1.4.8.1 1.4-.6 1.4-1.4zM7.6 8c0-.3-.2-.6-.5-.6s-.6.3-.6.6.2.6.5.6.6-.3.6-.6z" />
          </svg>
        );
      case "amenity_clinic":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M8 6h6.6c.2 0 .2 0 .2.2v6.7c0 .2 0 .2-.2.2h-2.8c-.2 0-.2 0-.2-.2V7.8c0-.4-.1-.4-.4-.4H5c-.4 0-.4.1-.4.4v5.1c0 .2 0 .2-.2.2H1.6c-.1 0-.2 0-.2-.2V6.2c0-.2 0-.2.2-.2H8zM8 5.4H1.3c-.5 0-.8-.3-.8-.8v-.3c.1-.3.4-.5.8-.5h4c.1 0 .2 0 .2-.2V1.4c0-.5.3-.8.8-.8h3.6c.5 0 .8.3.8.8v2.2c0 .1 0 .2.2.2h3.9c.5 0 .8.3.8.8v.2c0 .5-.3.7-.7.7-2.4-.1-4.7-.1-6.9-.1zM6.7 2.8c0 .2.1.3.3.3h.5c.1 0 .1 0 .1.1v.5c.1.3.2.4.4.4s.3-.1.3-.3v-.4c0-.2 0-.2.2-.2H9c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3h-.5c-.1 0-.2 0-.2-.2v-.5c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3v.4c0 .2 0 .2-.2.2H7c-.1 0-.3.2-.3.3zM8 13.8h7c.3 0 .5.1.5.5v.5c-.1.4-.5.7-1 .7H1.7c-.5 0-.8-.2-1-.6-.1-.2-.1-.5-.1-.7 0-.2.2-.3.3-.3h.9c2.1-.1 4.1-.1 6.2-.1z"
            />
            <path
              className="st1"
              d="M5.1 10.6V8.2c0-.2 0-.2.2-.2h2.2c.1 0 .2 0 .2.2V13c0 .1 0 .2-.2.2H5.2c-.1 0-.2-.1-.2-.2.1-.8.1-1.6.1-2.4zM10.9 10.6V13c0 .1 0 .2-.2.2H8.4c-.1 0-.2-.1-.2-.2V8.2c.1-.2.2-.2.3-.2h2.2c.2 0 .2.1.2.2v2.4z"
            />
          </svg>
        );
      case "amenity_hospital":
        return (
          <svg
            id="svg4264"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            fill="currentColor"
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st0"
              d="M5.2.4h5.6c.2.1.3.3.3.5V2c0 .1 0 .2.2.2h.3c.7 0 1.3.6 1.3 1.3v11.9c0 .1 0 .2-.2.2H9.4c-.1 0-.2 0-.2-.2V14c0-.1 0-.2-.2-.2H6.7c-.1 0-.2.1-.2.2v1.4c0 .1 0 .2-.2.2H3c-.2 0-.2 0-.2-.2V3.5c0-.5.3-.8.7-1.1.3-.2.6-.2 1-.2.1 0 .2 0 .2-.2V.9c.2-.2.3-.4.5-.5zm.6 3.1v2.1c0 .1 0 .2.2.2h4.1c.1 0 .2 0 .2-.2V1.5c0-.2 0-.2-.2-.2H6c-.2 0-.2 0-.2.2v2zm.9 4.1h.7c.1 0 .2 0 .2-.2v-.6c0-.1 0-.1-.1-.1H6c-.1 0-.1 0-.1.1v.6c0 .1 0 .2.2.2h.6zm2.7 0h.7c.1 0 .2 0 .2-.2v-.5c0-.1 0-.1-.1-.1H8.7c-.1 0-.1 0-.1.2v.6c0 .1 0 .2.2.2.1-.2.3-.2.6-.2zM6.7 9.4h.7c.1 0 .2 0 .2-.1v-.6c0-.1 0-.1-.1-.1H6c-.1 0-.1 0-.1.1v.6c0 .1 0 .2.2.2.1-.1.3-.1.6-.1zm2.7-.9h-.7c-.1 0-.1 0-.1.1v.6c0 .1 0 .1.1.1h1.5c.1 0 .2 0 .2-.1v-.6c0-.1 0-.1-.2-.1h-.8zm-2.7 1.8H6c-.1 0-.2 0-.2.1v.6c0 .1 0 .1.1.1h1.5c.1 0 .1 0 .1-.1v-.6c0-.1 0-.2-.2-.2-.1.1-.4.1-.6.1zm2.7 0h-.7c-.1 0-.1 0-.1.1v.6c0 .1 0 .1.1.1h1.5c.1 0 .2 0 .2-.1v-.6c0-.1 0-.1-.2-.1h-.8zM.4 7.8c.1-.3.2-.5.4-.7.3-.3.6-.4 1-.4s.4 0 .4.4v.4c0 .1 0 .1-.1.1h-.3c-.3 0-.5.2-.5.5v.2c0 .1 0 .2.1.2H2c.1 0 .2 0 .2.1v.6c0 .1 0 .1-.1.1h-.6c-.1 0-.1 0-.1.1v.6c0 .1 0 .2.1.2h.6c.1 0 .2 0 .2.1v.6c0 .1 0 .1-.1.1h-.6c-.1 0-.1 0-.1.1v.6c0 .1 0 .2.1.2h.6c.1 0 .2 0 .2.1v3.3c0 .1 0 .1-.1.1H1.1c-.2 0-.3-.1-.4-.3-.3-2.3-.3-4.8-.3-7.3zM15.6 11.6v3.5c0 .4-.2.5-.6.5h-1.1c-.1 0-.2 0-.2-.2v-3.3c0-.1 0-.2.2-.2h.6c.1 0 .2 0 .2-.2v-.6c0-.1 0-.1-.1-.1H14c-.1 0-.1 0-.1-.1v-.6c0-.1 0-.1.1-.1h.6c.1 0 .2 0 .2-.2v-.6c0-.1 0-.1-.1-.1h-.6c-.1 0-.1 0-.1-.1v-.6c0-.1 0-.1.1-.1h.6c.1 0 .2 0 .2-.2 0-.6-.1-.7-.7-.7-.2 0-.2 0-.2-.2v-.6c0-.1 0-.1.1-.1.4 0 .9 0 1.2.3.3.3.5.6.5 1-.2 1.2-.2 2.4-.2 3.6z"
            />
            <path
              className="st0"
              d="M9.4 3.6c0 .2-.2.4-.5.4h-.3c-.1 0-.2 0-.2.2v.3c0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.4v-.3c0-.1 0-.1-.1-.1-.1-.1-.2-.1-.3-.1-.2 0-.4-.2-.4-.4 0-.3.2-.5.4-.5h.3c.1 0 .2 0 .2-.1v-.3c0-.2.2-.4.5-.4.2 0 .4.2.5.4V3c0 .1 0 .1.1.1H9c.2 0 .4.2.4.5z"
            />
          </svg>
        );
      case "amenity_hotel":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M5.1 15.7c-.1-.1-.2-.2-.2-.3V6.1C4.9 5.4 5.3 5 6 5h4.3c.7 0 1.1.4 1.1 1.1v9.3c0 .2 0 .3-.2.3H9.7c-.1-.1-.2-.2-.2-.3v-2.7c0-.2-.1-.3-.3-.3H7.1c-.3 0-.3.1-.3.3v2.7c0 .2 0 .3-.2.3H5.1zm3.1-8.2H6.8c-.2 0-.3.1-.3.3 0 .1.1.2.3.2h2.8c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.5.1-1 .1-1.4.1zm0 2.9h1c.2 0 .3-.1.3-.2 0-.2-.1-.3-.3-.3H7.3c-.3 0-.4.1-.4.3 0 .2.1.3.3.3.3-.1.7-.1 1-.1zM12.1 15.7c-.1-.1-.2-.2-.2-.3V9c0-.3.1-.4.4-.4h1.2c.6 0 1 .4 1 1v5c0 .5-.3.9-.8 1h-.1c-.4.1-1 .1-1.5.1zm.7-4.1v.5c0 .2.1.3.3.3.1 0 .3-.1.3-.3v-1c0-.2-.1-.3-.3-.3-.1 0-.2.1-.3.3v.5zM2.7 15.7c-.1-.1-.1-.1 0 0-.6-.2-.8-.5-.8-1v-5c0-.7.4-1.1 1.1-1.1h1.2c.2 0 .3.1.3.3v6.5c0 .1-.1.2-.2.3H2.7zm.9-4.1v-.5c0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.3v1c0 .2.1.3.3.3.2 0 .2-.1.3-.3v-.5z"
            />
            <path
              className="st1"
              d="M8.9 15.7H7.5c-.1-.1-.2-.2-.2-.3v-2.3c0-.2.1-.3.3-.3h1.1c.3 0 .3.1.3.3v2.2c.1.2 0 .3-.1.4zM10 1.8s0 .1-.1.2c-.2.1-.4.3-.6.5 0 .1-.1.1 0 .2 0 .3.1.5.1.8 0 .1 0 .2-.1.3-.1.1-.2.1-.3 0-.2-.1-.5-.2-.7-.4H8c-.2.2-.4.3-.6.4-.1.1-.2.1-.3 0-.1-.1-.2-.2-.1-.3 0-.3.1-.5.1-.8 0-.1 0-.2-.1-.2-.2-.2-.3-.4-.5-.5-.1-.1-.2-.2-.1-.3 0-.1.1-.2.3-.2.3 0 .5-.1.8-.1.1 0 .2-.1.2-.1 0-.3.1-.5.2-.8.1-.1.2-.1.3-.2.1 0 .2.1.3.2.1.3.2.5.3.8 0 .1.1.1.1.1.3 0 .5.1.8.1.2 0 .3.1.3.3zM13.1 4.5c0-.1 0-.2-.1-.3-.1-.1-.1-.4.1-.4.1 0 .2-.1.3-.2.1-.2.3-.2.4 0 .1.1.1.2.3.2.2 0 .3.3.1.4-.1.1-.1.2-.1.3 0 .2-.2.4-.4.3-.1-.1-.2-.1-.3 0-.1.1-.3 0-.3-.3zM2.2 4.5c.1-.1 0-.2-.1-.3-.1-.2 0-.4.2-.4.1 0 .2-.1.3-.2.1-.2.3-.2.4 0 0 .1.1.2.2.2.3 0 .3.3.1.5v.2c0 .1 0 .2-.1.3h-.3c-.1-.1-.2 0-.3 0-.2.1-.4-.1-.4-.3zM10.8 3.2c.1-.1 0-.2-.1-.3-.1-.1-.1-.4.2-.4.1 0 .2-.1.3-.2.1-.2.3-.2.5 0 .1.1.1.2.2.2.2 0 .3.3.1.4-.1.1-.1.2-.1.3 0 .2-.2.4-.4.3-.1-.1-.2 0-.3 0-.2.1-.4 0-.4-.3zM4.5 3.2c.1-.1 0-.2-.1-.3-.2-.1-.1-.4.1-.4.1 0 .2-.1.3-.2.1-.2.3-.2.4 0 .1.1.1.2.3.2.2 0 .3.3.1.4-.1.1-.1.2-.1.3 0 .2-.2.4-.4.3-.1-.1-.2-.1-.3 0-.2.1-.3 0-.3-.3z"
            />
          </svg>
        );
  
      case "amenity_place_of_worship":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M7.7 9.5V7.4c0-.4.1-.4.5-.3.4.1.8.4.8.9v2c0 .3.2.5.6.5.2 0 .5-.2.5-.5 0-.8.1-1.6 0-2.3 0-.3-.2-.6-.3-.9-.7-1.1-1.2-2.2-1.7-3.2-.3-.5-.4-1-.4-1.5 0-.4.2-.7.4-1 .2-.2.3-.4.5-.5.2-.2.5-.1.6.1 0 .1.1.1.1.2 1 1.9 1.9 3.9 2.9 5.8.1.2.1.4.1.6V11c0 .1 0 .2.1.3l1.1 1.1c.3.3.3.6 0 .9-.7.7-1.4 1.5-2.2 2.2-.3.3-.6.3-.9 0l-2-2c-.4-.5-.7-1.2-.7-1.9V9.5zM7.4 9.6v2.1c0 .6-.2 1.2-.7 1.7-.7.7-1.4 1.4-2.1 2.2-.3.3-.6.3-.9 0l-2.2-2.2c-.3-.3-.3-.6 0-.9l1.1-1.1c.1-.1.2-.2.2-.4V7.3c0-.2 0-.3.1-.5l3-6c.1-.4.4-.4.7-.1.1.1.1.2.2.2.6.5.7 1.2.6 1.9-.1.3-.2.5-.3.8C6.5 4.7 6 5.8 5.4 6.8c-.2.5-.4 1-.4 1.5V10c0 .3.2.5.4.5s.5-.1.6-.3V8.1c0-.6.4-1 .9-1.1.4 0 .5 0 .5.3v2.3z"
            />
          </svg>
        );
      case "amenity_police":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M8.7 0c.4.1.8.1 1.2.2.7.2 1.4.6 1.9 1.2s.6 1.3.3 2.1c-.1.1-.1.2-.3.2H9.3c-.2 0-.2 0-.1-.2.2-.4.3-.9.3-1.4L9.4 2l-1.2-.6H8L6.8 2c-.1 0-.1 0-.1.1 0 .5 0 1 .3 1.4.1.1 0 .1-.1.1H4.3c-.1 0-.2 0-.2-.1-.3-.5-.2-1.1 0-1.6.4-.7.9-1.1 1.6-1.4C6.3.2 6.8.1 7.4 0h1.3zM11.3 15.7H8.7c-.2 0-.2 0-.2-.2v-4.3c0-.2 0-.2.2-.2h3.1c1.2 0 2.2 1 2.2 2.3v2.2c0 .2-.1.2-.2.2h-2.5zM4.9 6.8v-.6c0-.1 0-.1.1-.1.6.4 1.3.6 2 .7 1.3.2 2.5.1 3.7-.4.2-.1.3-.2.5-.3.1 0 .1 0 .1.1 0 .5 0 1.1-.1 1.6-.4 1.4-1.7 2.4-3.1 2.4-1.6 0-3-1.2-3.2-2.8-.1-.3 0-.5 0-.6zM3.5 15.7H2.3c-.1 0-.2 0-.2-.2v-2.3c0-1 .8-1.9 1.7-2.1.1 0 .1 0 .1.1v2.4c0 .1 0 .2.2.2h.6c.1 0 .1 0 .1.1v1.6c0 .1-.1.1-.2.1-.3.1-.7.1-1.1.1zM8.1 4.6h3c.2 0 .2 0 .2.2-.1.2-.3.4-.5.5-.4.3-1 .5-1.5.6-1 .2-2 .2-3-.1-.3-.1-.7-.3-1-.5-.2-.1-.3-.3-.4-.5-.1-.2-.1-.2.1-.2h3.1zM7.6 13.4v2.1c0 .1 0 .2-.2.2H5.9c-.1 0-.2 0-.2-.2v-1.6c0-.1 0-.2.2-.2h.6c.1 0 .2 0 .2-.2v-2.4c0-.2 0-.2.2-.2h.6c.1 0 .2 0 .2.2-.1.8-.1 1.6-.1 2.3zM5.8 12v.8c0 .1 0 .2-.2.2H5c-.1 0-.2 0-.2-.1v-1.6c0-.1 0-.1.1-.1h.7c.1 0 .1 0 .1.1.1.2.1.4.1.7z"
            />
            <path
              className="st1"
              d="M8.5 2.6c0 .3-.2.6-.4.8H8c-.2-.2-.3-.4-.4-.7v-.1c0-.1.4-.2.5-.2.1 0 .3.1.4.2z"
            />
          </svg>
        );
      case "amenity_post_office":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M1.1 3.8c.1-.1.1-.2.1-.2 0-.1.1-.1.1 0l.1.1C2.8 5 4.2 6.5 5.7 7.9c.1.1.1.1 0 .3l-4.3 4.3-.1.1c-.1.1-.1 0-.1 0 0-.1 0-.2-.1-.2V3.8zM14.9 12.3c-.1.3-.1.3-.4.1l-4.2-4.2c-.1-.1-.1-.1 0-.3l4.3-4.3c.1-.1.1-.1.2 0 0 .1 0 .1.1.2v8.5zM8 2.8h5.7c.2 0 .3 0 .5.1.1 0 .1.1 0 .1L9.3 7.9c-.4.4-.8.7-1.2 1.1-.1.1-.1.1-.2 0l-6-6c-.1-.1-.1-.1 0-.2.1 0 .3-.1.5-.1 1.8.1 3.7.1 5.6.1z"
            />
            <path
              className="st1"
              d="M8 13.3H2.3c-.2 0-.3 0-.5-.1-.1 0-.1-.1 0-.1l.1-.1 4.3-4.3c.1-.1.1-.1.3 0l1.2 1.2c.2.2.4.2.7 0l1.2-1.2c.1-.1.1-.1.2 0l4.4 4.4c.1.1.1.1 0 .2-.1 0-.3.1-.4.1-2-.1-3.9-.1-5.8-.1z"
            />
          </svg>
        );
      case "amenity_rack":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M14 10.4V5.5c1-.2 1.8-1 1.8-2.1 0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1 2.1c0 1 .8 1.9 1.8 2.1v4c-.6-.5-1.4-.8-2.2-.7-.1 0-.1 0-.2-.1-.4-.7-.7-1.5-1-2.2 0-.1 0-.1.1-.2.2-.1.5-.2.7-.2.2-.1.3-.3.3-.5-.1-.2-.3-.3-.6-.3-.4.1-.9.3-1.3.4-.2.1-.3.3-.2.6 0 .2.1.3.2.5 0 .1 0 .1-.1.2-.4 0-.7.1-1 .2-.8.2-1.5.4-2.3.6-.1 0-.1 0-.2-.1l-.3-.6c0-.1 0-.1.1-.1h.4c.1 0 .3 0 .3-.2.1-.1.1-.3.1-.4 0-.2-.2-.3-.4-.3H4.1c-.2 0-.4.2-.4.4 0 .3.2.5.4.5h.1c.1 0 .1 0 .2.1.1.3.3.7.4 1v.2c-.2.3-.4.5-.6.7 0 .1-.1.1-.2.1-1.1-.6-2.5-.3-3.3.7-.3.4-.4.8-.5 1.2V11.8C.4 13.1 1.5 14 2.8 14c1.2 0 2.2-.8 2.5-2 .1-.2.1-.2.3-.2h1c.2 0 .4-.1.5-.3.8-1.1 1.6-2.3 2.5-3.4 0 0 0-.1.1-.1 0 0 0 .1.1.1.1.4.2.6.3.9 0 .1 0 .2-.1.2-.8.7-1.2 1.5-1 2.5.2 1.4 1.5 2.4 2.9 2.3.1 0 .2 0 .4-.1v.1h3.5v-3.5l-1.8-.1c0 .1 0 0 0 0zm-1.2-8h1c.6 0 .9.3.9.8s-.3.8-.9.8h-.3v.6h-.7V2.4zM4.4 12c-.2.7-.9 1.2-1.7 1.2-.9 0-1.6-.7-1.7-1.6-.1-1 .6-1.9 1.7-2 .2 0 .5 0 .7.1.1 0 .1.1 0 .1-.3.4-.7.8-1 1.2-.1.1-.2.3-.1.5s.2.2.4.3h1.5c.3 0 .3 0 .2.2zm1.5-1H3.6c.4-.4.6-.7.9-1 .2-.2.5-.5.7-.8.1-.1.1-.1.1 0 .2.5.5 1.1.7 1.6.1.1.1.2-.1.2zm1-.6c-.1.1-.1.1-.1 0-.3-.6-.5-1.1-.8-1.7 0-.1 0-.1.1-.1.9-.2 1.7-.5 2.6-.7h.1c-.4.4-.7.9-1 1.3l-.9 1.2zm4.9 2.7h-.2c-.7 0-1.4-.4-1.7-1.1-.3-.7-.1-1.5.5-2 .1-.1.1-.1.2 0 .2.5.4.9.6 1.4.1.2.2.3.4.3.3 0 .5-.3.4-.6-.1-.3-.3-.7-.4-1-.1-.1-.1-.3-.2-.4 0-.1 0-.1.1-.1.4 0 .8.1 1.1.3.3.2.4.4.6.7-.5.2-.9.6-.9 1.2V13c-.2.1-.4.1-.5.1z"
            />
            <path
              className="st1"
              d="M14 3.1c0-.2-.1-.2-.2-.2h-.3v.5h.3c.1 0 .2-.1.2-.3z"
            />
          </svg>
        );
      case "amenity_school":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M4 15.5c-.4 0-.5-.3-.5-.6V6.6c0-.3 0-.2-.2-.1-.1.1-.3.2-.4.1-.2 0-.3-.2-.3-.4s.1-.4.2-.5c.2 0 .5-.1.7-.2 1.4-.6 2.7-1.2 4.1-1.8.1-.1.2-.1.2-.2V1.2c0-.4.2-.5.5-.5h1.8c.3 0 .5.1.5.4v.5c0 .3-.2.4-.5.4H8.9c-.1 0-.2 0-.2.2v1.3c0 .1 0 .2.1.2 1.5.7 2.9 1.3 4.4 2 .1.1.2.1.4.2s.3.4.2.6c-.1.2-.4.3-.6.2-.3-.1-.3-.1-.3.2v8.2c0 .3-.1.6-.4.6h-2.4v-3.2c0-.3-.2-.5-.5-.5H7c-.4 0-.5.2-.5.5v3.2c-1-.2-1.6-.2-2.5-.2zm4.2-5.6c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8c-1.1 0-1.8.8-1.8 1.8-.1 1 .8 1.8 1.8 1.8z"
            />
            <path
              className="st1"
              d="M.7 10.7c.1-.2.3-.3.6-.3H3c.1 0 .2 0 .2.2v5h-2c-.2 0-.4 0-.4-.5-.1-1.6-.1-2.8-.1-4.4zM13.2 15.5v-4.9c0-.2 0-.2.2-.2h1.7c.4 0 .6.2.6.5v4c0 .2-.1.4-.3.5-.6.1-1.6.1-2.2.1z"
            />
          </svg>
        );
      case "amenity_theatre":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M15.1 1.9v4.2c-.2 1.6-.9 3.1-2 4.3-.5.6-1.2 1.1-1.9 1.5-.7.5-1.5.5-2.2 0-.2-.1-.4-.3-.6-.4-.8-.6-1.4-1.1-1.9-1.8C5.6 8.4 5.1 6.9 5 5.3V2.1c0-.4.2-.7.7-.8C7.5.8 9.3.7 11.1.8c1.1.1 2.2.2 3.3.5.3.1.6.3.7.6zm-5 8.3c.3 0 .6-.1.8-.3.7-.6 1.5-1.2 2.2-1.8.1-.1.2-.2.1-.3-.1-.1-.2-.1-.3-.1-.5.1-1.1.2-1.6.3-.7.1-1.4.2-2.2 0l-1.8-.3c-.1 0-.3 0-.3.1-.1.1-.1.2.1.4.7.6 1.4 1.2 2.2 1.8.2.1.5.2.8.2zm-2.2-6c-.4 0-.8.1-1.2.4-.3.2-.3.2 0 .5.1.1.1.1.2 0 .6-.5 1.4-.5 2-.1.3.2.3.2.5-.1.1-.1.1-.1 0-.2-.5-.3-.9-.5-1.5-.5zm4.3 0c-.4 0-.8.1-1.2.4-.3.2-.3.2 0 .5.1.1.1.1.2 0 .6-.4 1.3-.5 1.9-.1.2.2.2.2.5 0 .1-.1.1-.2 0-.2-.5-.4-.9-.6-1.4-.6z"
            />
            <path
              className="st1"
              d="M7 15.5c-.7-.2-1.3-.5-2-.8-2-1.1-3.3-2.7-3.9-4.8C.9 9 .7 8 .4 7.1.3 6.6.4 6.3.8 6c1.1-.5 2.3-1 3.5-1.4.3-.1.3-.1.3.2 0 1 .1 2 .4 3 .5 1.3 1.2 2.4 2.2 3.4.1.1.1.1 0 .2-.5.2-1 .3-1.6.3-.6 0-1.1.1-1.7.1-.1 0-.2.1-.2.2s0 .2.2.3c.9.4 1.8.8 2.6 1.2.5.2 1.1.1 1.5-.4.2-.2.4-.5.5-.7.1-.1.1-.1.2-.1.4.3.9.4 1.4.4.1 0 .1.1.1.1-.3.5-.6 1-.9 1.4-.1.2-.3.3-.4.5-.3.4-.7.7-1.2.8-.3.1-.4.1-.7 0zm-3-7c-.7 0-1.2.3-1.6.8-.2.2-.2.2.1.4.1.1.2 0 .2-.1.5-.6 1.2-.8 1.8-.6.4.1.3.1.5-.2 0-.1 0-.1-.1-.2-.3-.1-.6-.1-.9-.1z"
            />
            <path
              className="st1"
              d="M6.9 13.1c-.1 0-.2 0-.3-.1-.5-.2-1-.5-1.5-.7 0 0-.1 0-.1-.1h.1c.6 0 1.2-.1 1.7-.2.3-.1.5-.2.8-.3h.3c.3.2.3.2.1.5-.1.2-.2.3-.4.5-.1.3-.3.4-.7.4zM12 8.4c0 .1 0 .1-.1.1-.4.3-.8.7-1.3 1-.4.3-.7.3-1.1 0-.4-.3-.8-.7-1.3-1 0 0-.1 0-.1-.1.6.1 1.3.3 1.9.3.7-.1 1.3-.2 2-.3z"
            />
          </svg>
        );
      case "amenity_toilets":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M15.9 14.2c-.1.2-.3.3-.6.3h-4.8c-.5 0-.7-.3-.5-.8.8-2.1 1.6-4.2 2.4-6.4.2-.1.3-.3.6-.3s.4.2.5.4l2.4 6.3s0 .1.1.1c-.1.2-.1.3-.1.4zM3.1 7h2.4c.4 0 .6.3.5.8-.8 2.1-1.6 4.2-2.5 6.3-.1.3-.4.5-.7.4-.2-.1-.2-.2-.3-.3-.3-1.1-.7-2.2-1.1-3.2C.9 9.9.5 8.8.1 7.8 0 7.3.2 7 .6 7h2.5zM3.1 1.5c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3-.1-1.3 1-2.3 2.3-2.3zM13 1.5c1.3 0 2.3 1 2.3 2.3 0 1.3-1.1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3-.1-1.3 1-2.3 2.3-2.3zM7.5 8V1.9c0-.3.2-.4.5-.4.2 0 .4.2.5.4v12.3c0 .2-.2.4-.5.4-.2 0-.4-.2-.5-.4V8z"
            />
          </svg>
        );
      case "amenity_university":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M11.2 15.5V8.6c0-.1.1-.2.2-.2h3.9V15c0 .3-.2.5-.5.5h-3.6zm2.4-4.9v-.3c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.6c0 .2.2.4.4.4s.4-.2.4-.4v-.3zm0 2.3v-.3c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.7c0 .2.2.4.4.4s.4-.2.4-.4v-.4zM.8 15.5c-.4 0-.5-.3-.5-.5V8.6c0-.2 0-.2.2-.2h3.7c.1 0 .2 0 .2.2v7c-1.2-.1-2.3-.1-3.6-.1zm1.3-4.9v.3c0 .2.2.4.4.4s.4-.2.4-.4v-.7c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.4zm.8 2.3v-.3c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.6c0 .2.2.4.4.4s.4-.2.4-.4v-.3zM5.4 15.5V8.6c0-.2 0-.2.2-.2h4.6c.1 0 .2 0 .2.2v7H9.2v-2c0-.8-.8-1.4-1.6-1.2-.6.1-1 .6-1 1.2v2c-.4-.1-.8-.1-1.2-.1zm1.2-4.9v.3c0 .2.2.4.4.4s.4-.2.4-.4v-.6c0-.3-.2-.4-.4-.4s-.4.2-.4.4v.3zm2.6 0v-.3c0-.3-.2-.4-.4-.4s-.4.2-.4.4v.7c0 .2.2.4.4.4s.4-.2.4-.4v-.4zM15.3 6.3c-.1.2-.2.3-.4.3s-.2.1-.3.3c0 .2 0 .4.2.6H.9c.1-.1.2-.1.2-.3v-.3c0-.1-.1-.2-.3-.2H.6c-.2 0-.4-.3-.3-.5 0-.2.2-.4.4-.4h13.9c.3 0 .4.1.5.3.2 0 .2.1.2.2z"
            />
            <path
              className="st1"
              d="M7.4 15.5v-2c0-.3.2-.4.4-.5.3 0 .4.2.5.4v2c-.3.1-.6.1-.9.1zM11.2 4.9H4.5c.1-.1.1-.1.2-.1.9-.3 1.7-.7 2.6-1 .1 0 .2-.1.2-.2V1c0-.4.4-.6.7-.4.1.1.2.1.2.2-.1.2 0 .2.1.2h1.4c.1 0 .3 0 .3.2.1.1 0 .3 0 .4-.2.2-.2.5 0 .7.1.1.1.2.1.3 0 .2-.1.3-.3.3H8.6c-.1 0-.2 0-.2.2v.7c0 .1 0 .2.1.2.8.3 1.7.6 2.5 1 0-.2.1-.2.2-.1 0-.1 0-.1 0 0z"
            />
          </svg>
        );
      case "bicycle_store":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path d="M7.4.3h1.3c.4 0 .6.2.6.6 0 1.1 1.1 1.9 2.1 1.6.3-.1.6-.2.8-.5.2-.2.4-.2.6 0 .5.4.9.8 1.2 1.2.1.2.1.4 0 .6l-.1.1c-.8.8-.4 2.3.6 2.7.2.1.5.1.7.1.3 0 .4.2.5.5v1.4c0 .4-.2.6-.6.6H15c-1 0-1.7 1-1.5 1.9.1.4.3.7.5 1 .2.2.2.4 0 .6-.4.5-.8.9-1.2 1.2-.1.1-.3.1-.4.1-.1 0-.2-.1-.3-.2-.4-.4-.9-.5-1.4-.4-.8.1-1.4.8-1.4 1.6 0 .4-.2.5-.5.6H7.4c-.4 0-.5-.2-.5-.6 0-.2 0-.4-.1-.6-.3-.7-1-1.2-1.8-1-.4.1-.7.2-1 .5-.2.2-.4.2-.6 0l-1.2-1.2c-.1-.1-.1-.3-.1-.5 0-.1.1-.2.2-.2.7-.7.6-1.9-.2-2.5-.5-.1-.8-.2-1.2-.3-.4 0-.5-.2-.6-.5V7.2c0-.3.2-.5.5-.5h.4c.9-.2 1.4-.8 1.4-1.7 0-.5-.2-.8-.5-1.1-.2-.3-.2-.5-.1-.7.4-.5.8-.9 1.2-1.2.2-.2.4-.2.6 0l.1.1c.6.6 1.7.6 2.3 0 .3-.3.5-.7.5-1.2 0-.4.2-.5.5-.5.1-.1.2-.1.2-.1zM8 12.4c.8 0 1.5-.2 2.2-.6.1-.1.1-.1 0-.2-.5-.6-1.1-1.1-1.7-1.7-.1-.1-.1-.1-.2 0-1.2.3-2.3 0-3.1-.9-.5-.7-.7-1.5-.5-2.4 0-.2.2-.3.3-.3.1 0 .2.1.3.2l1.1 1.1c.1.1.1.1.3.1.3 0 .5-.1.8-.1.1 0 .2-.1.2-.2 0-.2.1-.5.1-.7 0-.2 0-.3-.1-.4-.4-.3-.8-.7-1.2-1.1-.2-.2-.1-.5.2-.6.3-.1.7-.1 1-.1 1.7.2 2.8 2 2.2 3.6 0 .1 0 .2.1.3.6.5 1.1 1.1 1.7 1.6.1.1.1.1.2 0 .4-.8.6-1.7.5-2.6-.1-1.2-.7-2.1-1.6-2.9-1.3-.9-2.8-1.2-4.3-.6-2 .7-3.2 2.9-2.8 5 .4 2 2.2 3.5 4.3 3.5z" />
          </svg>
        );
      case "tourism_gallery":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 14 14"
            fill="currentColor"
            style={{
              enableBackground: "new 0 0 14 14",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st0"
              d="M7 13.7c-.4-.1-.8-.2-1.1-.4-.6-.3-.5-.3-1.2-.3h-.8c-.2 0-.4.1-.5.2-.4.4-.9.5-1.5.4-.2 0-.2-.1-.3-.3-.1-.5 0-1 .4-1.4.2-.2.2-.4.2-.6V9.2c0-.2-.1-.4-.2-.6-.3-.5-.5-1-.5-1.6 0-.2 0-.5.1-.7.1-.3.2-.6.4-.9.2-.2.2-.4.2-.6v-2c0-.2-.1-.4-.2-.6-.4-.5-.5-1-.4-1.5 0-.2.1-.3.3-.3.5-.1 1 0 1.4.4.2.1.4.2.7.2h1.2c.2 0 .3 0 .5-.1C6 .6 6.5.4 7 .3c.4-.1.8 0 1.2.2.3.1.5.2.7.4.2 0 .3.1.5.1h1.2c.2 0 .4-.1.5-.2.4-.4.9-.5 1.5-.4.2 0 .2.1.3.3.1.5 0 1-.4 1.5-.2.2-.2.4-.2.6v2.1c0 .2.1.4.2.6.3.4.5.9.5 1.5 0 .3-.1.6-.2.9-.1.3-.2.5-.4.7-.1.2-.2.3-.2.5v2.1c0 .2.1.4.2.6.3.4.5.9.4 1.4 0 .2-.1.3-.3.4-.5.1-1 0-1.4-.4-.1-.1-.3-.2-.5-.2H9.4c-.1 0-.2 0-.3.1-.5.3-1 .5-1.5.6H7zm-2.5-1.2h1.4c.3 0 .7.1.7.5 0 .1.1.2.2.2s.2-.1.2-.2 0-.3-.1-.4c0-.1 0-.1.1-.1h.6c.1 0 .1 0 .1.1-.1.1-.1.2-.1.4s.1.2.2.3c.1 0 .2-.1.2-.2 0-.2.2-.4.4-.5h3c.1 0 .1 0 .2.1l.3.3c.1.1.2.1.3 0 .1-.1.1-.2 0-.3l-.3-.3c-.1-.1-.1-.2-.1-.3V8.4c0-.3.2-.6.5-.6.1 0 .2-.1.2-.2s-.1-.2-.2-.2-.3 0-.4.1c-.1 0-.1 0-.1-.1v-.6c0-.1 0-.1.1-.1.1.1.2.1.4.1s.3-.1.3-.2-.1-.2-.2-.2c-.2 0-.4-.2-.4-.4 0-.1-.1-.2-.1-.4V2c0-.1 0-.1.1-.2l.3-.3c.1-.1.2-.3.1-.4-.3-.1-.4-.1-.5 0l-.3.3-.1.1H8.7c-.5 0-.7-.2-.7-.5 0-.1-.1-.2-.2-.2-.2 0-.3.1-.3.2s0 .3.1.4c0 .1 0 .1-.1.1h-.6c-.1 0-.1 0-.1-.1.2-.1.2-.2.2-.3 0-.2-.1-.2-.2-.3-.1 0-.2.1-.2.2 0 .2-.2.4-.4.4-.1.1-.2.1-.3.1H3.2c-.1 0-.2 0-.2-.1-.1-.1-.3-.2-.4-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3l.3.3c.1.1.1.2.1.3V5.7c0 .4-.2.5-.5.6-.1 0-.2.1-.2.2s.1.2.2.2.3 0 .4-.1c.1 0 .1 0 .1.1v.6c0 .1 0 .1-.1.1-.1-.1-.2-.1-.3-.1-.2 0-.3 0-.3.2 0 .1.1.2.2.2.2 0 .4.2.4.4 0 .1.1.3.1.4v3.6c0 .1 0 .1-.1.2l-.3.3c-.1.1-.1.3 0 .3.1.1.2.1.3 0l.3-.3c.1-.1.2-.1.3-.1h1.3z"
            />
            <path
              className="st0"
              d="M11.5 7v5.1c0 .2 0 .2-.2.2H3.1c-.2 0-.2 0-.2-.2C3 8.7 3 5.3 3 1.9c0-.2 0-.2.2-.2h8.2c.2 0 .2 0 .2.2-.1 1.7-.1 3.4-.1 5.1zM11 7V2.8c0-.4-.2-.5-.5-.6H4.1c-.3 0-.5.2-.5.5v8.4c0 .4.2.5.5.5H10.8c.2-.1.3-.3.3-.5C11 9.8 11 8.4 11 7z"
            />
          </svg>
        );
      case "tourism_hotel":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            fill="currentColor"
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M7.7 6h.1l.1-.1c.2-.2.2-.2.3-.1.5.5.9 1.1 1.4 1.6.4.4.7.8 1.1 1.2.2.2.5.3.8.2.3-.2.5-.4.5-.8 0-.2-.1-.4-.3-.5C9.5 5.3 7.3 3.1 5 .9c-.1-.1-.3-.1-.3.1-.2.3-.3.7-.2 1.1 0 .5.2.9.5 1.2L7.7 6zM9.2 4.4c.1.1.2.1.3.1h.1c.3 0 .5-.1.7-.3l1.6-1.6v-.1l-.2-.2c-.1-.1-.1-.1-.1 0l-.4.4-.8.8c-.1.1-.1 0-.1 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1 0-.2l1.1-1.1c.1-.1.1-.1 0-.2l-.1-.1c-.1-.1-.1-.1-.2 0-.5.2-.9.6-1.2.9 0 0-.1.1-.1 0-.1 0-.2-.1-.2-.2-.1-.1-.1-.1 0-.1.4-.4.7-.8 1.1-1.1.1-.1 0-.1 0-.1l-.3-.3-1.6 1.6c-.2.2-.3.4-.4.7V3.5l.9.9zM4.1 8.3c.1.3.4.5.7.5.2 0 .3-.1.5-.2.7-.8 1.4-1.5 2.1-2.2.1-.1.1-.1 0-.1l-.9-.9c-.1-.1-.1-.1-.1 0l-2 2c-.2.2-.3.4-.4.6 0 .1.1.2.1.3z"
            />
            <path
              className="st1"
              d="M15 12.7c0-.1 0-.2-.1-.1H2.1c-.2 0-.2 0-.2-.2V7.9c0-.1 0-.2-.2-.2H.9v8h.8c.2 0 .2 0 .2-.2v-.6c0-.2 0-.2.2-.2h11.8c.2 0 .2 0 .2.2v.6c0 .1 0 .2.2.2h.6c.1 0 .1 0 .1-.1v-2.9zM1.9 15.3s0-.1 0 0z"
            />
            <path
              className="st1"
              d="M5.2 10.7v1.4c0 .2 0 .2.2.2h8.8c.1 0 .2 0 .2-.1v-1.4c0-.6-.4-.9-.9-.9H6.2c-.6-.1-.9.3-1 .8zM3.4 12.4c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3z"
            />
          </svg>
        );
      case "tourism_museum":
        return (
          <svg
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            fill="currentColor"
            viewBox="0 0 16 16"
            style={{
              enableBackground: "new 0 0 16 16",
            }}
            xmlSpace="preserve"
            {...props}
          >
            <path
              className="st1"
              d="M8 5.6H1.1C.7 5.6.5 5.4.5 5v-.6c0-.2.1-.4.3-.5 1.6-.8 3.3-1.7 4.9-2.5.7-.3 1.3-.7 2-1 .2-.1.3-.1.5 0 2.3 1.2 4.6 2.4 6.9 3.5.2.1.3.3.3.5v.7c0 .3-.2.5-.5.5H8zm0-3.8c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2.7 0 1.2-.6 1.2-1.2S8.7 1.8 8 1.8zM8 15.6H1c-.2 0-.3-.1-.3-.3v-.7c0-.2.1-.3.3-.3h.8c.1 0 .2 0 .2-.2v-.4c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5v.4c0 .1 0 .1.1.1h5.5c.2 0 .2 0 .2-.2v-.3c0-.3.2-.4.5-.4h2.1c.3 0 .5.2.5.5v.4c0 .1 0 .2.1.1h.8c.3 0 .4.1.4.4v.7c0 .2-.1.3-.3.4h-.2c-2.3-.2-4.5-.2-6.7-.2zM8 6h6.8c.1 0 .1 0 .1.1v.7c0 .2-.2.4-.5.4H14c-.1 0-.2 0-.2.2v.4c0 .3-.2.4-.4.5h-2c-.4 0-.6-.2-.6-.6 0-.4 0-.4-.4-.4H5.2c-.2-.1-.2-.1-.2.1v.3c0 .3-.1.5-.3.5H2.5c-.3 0-.4-.2-.4-.5v-.4c0-.1 0-.2-.2-.1h-.4c-.3 0-.4-.2-.4-.5v-.6c0-.1 0-.1.1-.1H8z"
            />
            <path
              className="st1"
              d="M8 7.7h2.3c.1 0 .2 0 .2.2 0 .3.1.5.4.6 0 0 .1.1.1.2v3.9c0 .1 0 .2-.1.3-.2.1-.4.4-.4.6 0 .1-.1.2-.2.2h-.4c-.1 0-.2-.1-.2-.2V11c0-.9-.8-1.6-1.7-1.6-.9 0-1.7.7-1.7 1.6v2.5c0 .3 0 .3-.3.3h-.4c-.1-.1-.1-.2-.1-.4-.1-.2-.2-.3-.3-.4-.2-.2-.2-.2-.2-.3V8.8c0-.1 0-.2.1-.2.3-.2.4-.4.4-.7 0-.1.1-.2.2-.2H8zM13.4 10.7v1.8c0 .1 0 .2-.2.2h-1.6c-.2 0-.2-.1-.2-.2V8.8c0-.1 0-.2.2-.2h1.6c.1 0 .2.1.2.2v1.9zM2.6 10.7V8.9c0-.2 0-.2.2-.2h1.5c.1 0 .2 0 .2.2v3.7c0 .2 0 .2-.2.2H2.7c-.1 0-.2 0-.2-.2.1-.7.1-1.3.1-1.9z"
            />
          </svg>
        );
  
      default:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={14}
            fill="currentColor"
            {...props}
          >
            <path d="M4 4 2 6v8h10V6l-2-2zm2 2h2v2h2v2H8v2H6v-2H4V8h2zM4 0v3h6V0z" />
          </svg>
        );
    }
  };
  
  export default ParcoSvg;
  